import { AfterViewChecked, Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzIconService } from 'ng-zorro-antd/icon';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Router } from '@angular/router';
import { SiteDataService } from "../../../services/utils/site-data.service";
import { environment } from "../../../../environments/environment";
import { en_US, NzI18nService, zh_CN } from "ng-zorro-antd/i18n";
import { SiteService } from "../../../services/site.service";
import { Store } from '@ngrx/store';
import * as shrinkActions from "src/app/services/state/actions/shrink.action";
import { AuthenticationService } from "../../../services/utils/authentication.service";
import { CookieService } from 'ngx-cookie-service';
import { TenantService } from 'src/app/pages/tenant/services/tenant.service';
@Component({
  selector: 'app-basic-layout',
  templateUrl: './basic-layout.component.html',
  styleUrls: ['./basic-layout.component.scss']
})
export class BasicLayoutComponent implements OnInit, AfterViewChecked {
  product = environment.product;
  isCollapsed = false;
  menus;
  tenantInfo;

  constructor(
    public router: Router,
    private translateService: TranslateService,
    private siteDataService: SiteDataService,
    private siteService: SiteService,
    private nzI18nService: NzI18nService,
    private iconService: NzIconService,
    private store: Store,
    private authenticationService: AuthenticationService,
    private cookieService: CookieService,
    private tenantService: TenantService
  ) {
    this.iconService.fetchFromIconfont({
      scriptUrl: environment.ICON_FONT_URL
    });
    let defaultLang = 'zh';
    let local = zh_CN;
    if (localStorage.getItem('defaultLang')) {
      defaultLang = localStorage.getItem('defaultLang');
    }

    /* --- set i18n begin ---*/
    this.translateService.addLangs(['zh', 'en', 'ja']);
    this.translateService.setDefaultLang(defaultLang);
    // const browserLang = this.translateService.getBrowserLang();
    this.translateService.use(defaultLang);

    switch (defaultLang) {
      case 'en': { local = en_US; break; }
      case 'zh': { local = zh_CN; break; }
      // case 'ja': { local = ja_JP; break; }
      default: local = en_US;
    }
    this.nzI18nService.setLocale(local);
    /* --- set i18n end ---*/
  }

  async ngOnInit() {
    if (!environment.isAdmin ){
      this.tenantInfo = await this.tenantService.getTenantInfo().toPromise();
    }
    this.loadMenus();
    this.tokenRefresh();
    document.getElementById('dynamicTitle').innerText =this.product==='YC'?'数企通':'易享云'
  }
  
  ngAfterViewChecked(): void {
    // new PerfectScrollbar(document.querySelector('#sideBar'));
  }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }

  activeRouteEx(menu): boolean {
    return menu.children.some(item=>this.router.url==item.menuUrl)
  }
  
  switchLanguage(lang) {
    this.translateService.use(lang);
    localStorage.setItem('defaultLang', lang);
    switch (lang) {
      case 'en': {
        this.nzI18nService.setLocale(en_US);
        break;
      }
      case 'zh': {
        this.nzI18nService.setLocale(zh_CN);
        break;
      }
      default:
        this.nzI18nService.setLocale(en_US);
    }
  }

  toggleCollapse($event) {
    localStorage.setItem('naviCollapsed', $event.toString());
    this.store.dispatch(new shrinkActions.SetShrink($event))
  }

  async loadMenus() {
    //20220211 baij 给角色改权限，角色还没退出菜单就换了
    //将数据放到缓存中 当用户退出清理缓存

    let menukey = 'halo-menu'
    let menus ;
    menus= await sessionStorage.getItem(menukey) || ''; //sessionStorage异步 会导致【菜单】切换菜单时，闪白色 
    if (!menus) {
      menus = await this.siteService.getMenus();
      await sessionStorage.setItem(menukey, JSON.stringify(menus))
    } else {
      menus = JSON.parse(menus);
    }
    this.menus = menus;
    // const menus = await this.siteService.getMenus();
    // console.log("loadMenus",menus)
    // this.menus = menus;
  }

  activeCondition(routename: Array<string>): boolean {
    return routename.includes(this.router.url);
  }


 //无感刷新token
 tokenRefresh() {
  window['refreshTokenInterval'] = setInterval(() => {
    this.authenticationService.refreshToken();
  },60000*60);  //  
}

ngOnDestroy(): void {
  clearInterval(window['refreshTokenInterval']);
}

}
